<template>
  <!-- Navbar -->
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    id="navbarBlur"
    data-scroll="true"
  >
    <div
      class="container-fluid py-1 px-3"
      @mouseover="
        (event) => $refs.tooltip && $refs.tooltip.handleMouseOver(event)
      "
      @mouseout="
        (event) => $refs.tooltip && $refs.tooltip.handleMouseOut(event)
      "
    >
      <Tooltip
        ref="tooltip"
        :anchor-element="'target'"
        :position="'right'"
        :open-delay="299"
        :tooltip-style="text"
      />
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
          <li class="breadcrumb-item text-sm">
            <a
              class="opacity-3 text-dark"
              href="javascript:;"
              @click.stop="goToPage('/Home')"
            >

              <i
                class="material-icons text-lg position-relative py-1"
                title="請點選回到首頁"
              >home</i>

            </a>
          </li>
          <li 
            v-show="layer1 != null && layer1Name != null"
            class="breadcrumb-item text-sm"
          >
            <a
              class="opacity-5 text-dark"
              href="javascript:;"
            >{{ layer1Name }}</a>
          </li>
          <li 
            v-show="layer2 != null && layer2Name != null"
            class="breadcrumb-item text-sm"
          >
            <a
              class="opacity-5 text-dark"
              href="javascript:;"
            >{{ layer2Name }}</a>
          </li>
          <li
            v-show="layer3 != null && layer3Name != null"
            class="breadcrumb-item text-sm text-dark active"
            aria-current="page"
          >
            {{ layer3Name }}
          </li>
        </ol>
        <h6
          v-if="layer3Name != null && layer3Name != ''"
          class="font-weight-bolder mb-0"
        >
          {{ layer3Name }}
        </h6>
        <h6
          v-else-if="layer2Name != null && layer2Name != ''"
          class="font-weight-bolder mb-0"
        >
          {{ layer2Name }}
        </h6>
      </nav>
      <div
        class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none "
      >
        <a
          href="javascript:;"
          class="nav-link p-0"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line bg-dark" />
            <i class="sidenav-toggler-line bg-dark" />
            <i class="sidenav-toggler-line bg-dark" />
          </div>
        </a>
      </div>







      <div
        class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
        id="navbar"
      >
        <div class="ms-md-auto pe-md-3 d-flex align-items-center">
          <div class="input-group input-group-outline">
            <label class="form-label">Search here</label>
            <input
              type="text"
              class="form-control"
              onfocus="focused(this)"
              onfocusout="defocused(this)"
            >
          </div>
        </div>
        <ul
          class="navbar-nav  justify-content-end"
        >
          <li
            class="nav-item px-3"
          >
            <a
              class="nav-link p-0"
              @click.stop="logout()"
            >

              <i
                class="material-icons fixed-plugin-button-nav cursor-pointer"
                title="點選登出本系統"
              >
                logout
              </i>
            </a>
          </li>
          <!--
          <li
            class="nav-item"
            data-toggle="tooltip"
            title="Logout"
          >
            <a
              href="javascript:;"
              class="nav-link text-body p-0 position-relative"
              @click="goToPage('/AuthPage/SignIn')"
            >
              <i class="material-icons me-sm-1">
                logout
              </i>
            </a>
          </li>
          -->

          <li class="nav-item">
            <a
              href="javascript:;"
              class="nav-link p-0 position-relative"
            >
              <i
                class="material-icons me-sm-1"
                title="個人資訊"
              >
                account_circle
              </i>
            </a>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="javascript:;"
              class="nav-link p-0"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-dark" />
                <i class="sidenav-toggler-line bg-dark" />
                <i class="sidenav-toggler-line bg-dark" />
              </div>
            </a>
          </li>
          <li class="nav-item px-3">
            <a
              href="javascript:;"
              class="nav-link p-0"
            >
              <i
                class="material-icons fixed-plugin-button-nav cursor-pointer"
                title="設定"
              >
                settings
              </i>
            </a>
          </li>
          <li class="nav-item dropdown pe-2">
            <a
              href="javascript:;"
              class="nav-link p-0 position-relative"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                class="material-icons cursor-pointer"
                title="訊息通知"
              >
                notifications
              </i>
              <span
                class="position-absolute top-5 start-100 translate-middle badge rounded-pill bg-danger border border-white small py-1 px-2"
              >
                <span
                  class="small"

                  title="您有 11 則通知"
                >11</span>
                <span class="visually-hidden">unread notifications</span>
              </span>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end p-2 me-sm-n4"
              aria-labelledby="dropdownMenuButton"
            >
              <li class="mb-2">
                <a
                  class="dropdown-item border-radius-md"
                  href="javascript:;"
                >
                  <div class="d-flex align-items-center py-1">
                    <span class="material-icons">email</span>
                    <div class="ms-2">
                      <h6 class="text-sm font-weight-normal my-auto">
                        Check new messages
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2">
                <a
                  class="dropdown-item border-radius-md"
                  href="javascript:;"
                >
                  <div class="d-flex align-items-center py-1">
                    <span class="material-icons">podcasts</span>
                    <div class="ms-2">
                      <h6 class="text-sm font-weight-normal my-auto">
                        Manage podcast session
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item border-radius-md"
                  href="javascript:;"
                >
                  <div class="d-flex align-items-center py-1">
                    <span class="material-icons">shopping_cart</span>
                    <div class="ms-2">
                      <h6 class="text-sm font-weight-normal my-auto">
                        Payment successfully completed
                      </h6>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { h, ref, toRefs , reactive , watch , inject , onMounted , onUpdated , onBeforeUpdate} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { config, oltConsole, oAA , oApiError , oAdminFrame , oUserInfo , oAuth , oUrl } from '@/lib/oltModule/initAdminVue3';
//import moment from 'moment' ;
import { useI18n } from 'vue-i18n';
//import Loading from 'vue-loading-overlay';
//import 'vue-loading-overlay/dist/vue-loading.css';
import { useStore } from 'vuex';

import { FontIcon, SvgIcon } from '@progress/kendo-vue-common';
import { globeIcon } from '@progress/kendo-svg-icons';
import { Popup } from '@progress/kendo-vue-popup';
import { ComboBox } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { Button, ButtonGroup , DropDownButton } from '@progress/kendo-vue-buttons';
import { Tooltip } from '@progress/kendo-vue-tooltip';
export default {
  name: 'App',
  components: {
    //Loading,
    //Popup , 
    //ComboBox,
    //KButton : Button,
    //KButtonGroup : ButtonGroup,
    //DropDownButton : DropDownButton , 
    Tooltip : Tooltip,
    //FontIcon,
    //SvgIcon,
  },
  props: {
    routerChangeNumber: {
      type: Number ,
      required:0,
    },
  },
  setup(props,{emit}) {
    const { routerChangeNumber } = toRefs(props);

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    /**
     *  swal start
     */
    const swal = inject('$swal') ;
    /**
     *  swal end 
     */

    /**
     *  i18n Start 
     */
    const { t, locale } = useI18n({
      useScope:'global' // 必需設定 SCOPE 才能覆蓋設定
    }); 

    locale.value = 'zh-TW';
    /**
     *  i18n end 
     */
    

    const rounterName = ref('');
    const rounterPath = ref('');
    const layer1 = ref(null);
    const layer2 = ref(null);
    const layer3 = ref(null);
    const layer1Name = ref(null);
    const layer2Name = ref(null);
    const layer3Name = ref(null);

    //const locationUrl = ref(oUrl.getStoreLocationUrl(store));   

    //console.log('NavBar LocationUrl : ' , locationUrl);

    
    /**
     *  initAdmion.js Start
     *  修改新增資料 在 刷新時重新初始化 material dashboard 的 js 設定 
     */
    // Reload MDInput Start
    const initInput = async () => {
      //console.log('NavBar onMounted');
      // eslint-disable-next-line no-undef
      await oAdminFrame.initMdInput() ;

      reloadRouter();
    };

    onMounted(initInput);
    // Reload MDInput End

    onUpdated( async () => {
      //console.log('NavBar onUpdated');
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;

    }) ;
    /**
     *  initAdmion.js End
     */
    
    onBeforeUpdate( async () => {
	    //console.log('NavBar onBeforeUpdate');
    });

    watch(routerChangeNumber, (newValue, oldValue) => {
      //console.log('watch routerChangeNumber : ', newValue);

      reloadRouter();
    });    


    function logout(){
      oAuth.logout(router,store,swal,t) ; 
    }

    function goToPage(page){
      router.push( { path: page } );
    }

    function reloadRouter(){
      //console.log('old rounterName : ', rounterName.value);
      //console.log('old rounterPath : ', rounterPath.value);
      //console.log('route : ', route);
      //console.log('router : ', router);
      //console.log('router.currentRoute : ', router.currentRoute);
      //console.log('router.currentRoute.value : ', router.currentRoute.value);
      //console.log('router.currentRoute.value.name : ', router.currentRoute.value.name);
      //console.log('router.currentRoute.value.path : ', router.currentRoute.value.path);

      let isChange = false;

      if(router != null && router.currentRoute != null && router.currentRoute.value != null){
        if(router.currentRoute.value.name != null && router.currentRoute.value.name != rounterName.value){
          rounterName.value = router.currentRoute.value.name;
          isChange = true;
        }
        if(router.currentRoute.value.path != null && router.currentRoute.value.path != rounterPath.value){
          rounterPath.value = router.currentRoute.value.path;
          isChange = true;
        }
      }
      //console.log('rounterName : ', rounterName.value);
      //console.log('rounterPath : ', rounterPath.value);
      //console.log('isChange : ', isChange);
      let funData = null;
      let moduleData = null;
      let funNodeData = null;

      if(isChange == true){
        funData = oUserInfo.getAdminFunsByFunsCode(store, rounterName.value);
        moduleData = oUserInfo.getAdminModulesByFunsCode(store, rounterName.value);
        if(funData != null && funData.node != null && funData.node > 0){
          funNodeData = oUserInfo.getAdminFunsByFunsID(store, funData.node);
        }

        // setting layer1
        if(moduleData != null){
          layer1.value = moduleData;
          layer1Name.value = moduleData.name;
        }
        else{
          layer1.value = null;
          layer1Name.value = null;
        }

        // setting layer2
        if(funNodeData != null){
          layer2.value = funNodeData;
          layer2Name.value = funNodeData.name;
        }
        else if(funData != null){
          layer2.value = funData;
          layer2Name.value = funData.name;
        }
        else{
          layer2.value = null;
          layer2Name.value = null;
        }

        // setting layer3
        if(funNodeData != null && funData != null){
          layer3.value = funData;
          layer3Name.value = funData.name;
        }
        else{
          layer3.value = null;
          layer3Name.value = null;
        }
      }
      //console.log('funData : ', funData);
      //console.log('moduleData : ', moduleData);
      //console.log('funNodeData : ', funNodeData);
    }

    return {
      // i18n
      t,
      locale,      
      // const data
      rounterName,
      rounterPath,
      layer1,
      layer2,
      layer3,
      layer1Name,
      layer2Name,
      layer3Name,
      // function
      goToPage,
      logout,
    };
  },
};
</script>